// extracted by mini-css-extract-plugin
export default {"customers":"CN","wrapper":"EN","carousel":"FN","carousel_inner_wrapper":"GN","top_quote":"HN","bottom_quote":"IN","carousel_wrapper":"JN","feedbacks_wrapper":"KN","arrows":"LN","prev":"MN","img":"NN","review_btn":"ON"};
    if(module.hot) {
      // 1713912566450
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  